import React from 'react';
import cx from 'classnames';
import Card from '../../components/Card';
import { useStateContext } from '../../context/StateContext';
import style from './payment-info.module.scss';

const PaymentTitleInfo = ({ containerClass, contentClass }) => {
	const { state } = useStateContext();
	const { pageSettings: { firmName  } = {} } = state;

	return (
		<Card
			className={cx(style.container, containerClass)}
			customContentClass={cx(style.content, contentClass)}>
			Bu ödeme işlemini <span className={style.company}>{firmName}</span> için yapmaktasınız.
		</Card>
	);
};

export default PaymentTitleInfo;
